import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import ErrorTrackingService from './errorTrackingService';

export const fetchJson = async (url) => {
  try {
    const response = await axios(`${url}?timestamp=${Date.now()}`, {
      method: 'GET',
    });

    return response?.data;
  } catch (error) {
    ErrorTrackingService.logError(error);

    return null;
  }
};
